import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AgeGate from '../components/common/AgeGate';
import AppRouter from '../routes/AppRouter';
import { productApi } from '../services/api/productApi';
import { AuthProvider } from '../store/AuthContext';
import { CartProvider } from '../store/CartContext';

function App() {
  useEffect(() => {
    productApi.preloadProducts().catch(() => {
    });
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <AgeGate>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AgeGate>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
